import type { State } from "~/services";
import { ConfirmDialog } from "~/ui/common/Modal/ConfirmDialog";
import {
  REGISTRATION_STATUS,
  type RegistrationStatus,
} from "../utils/get-registration-status";

interface RegistrationAlertDialogProps {
  status: RegistrationStatus | null;
  state?: State;
  onContinue: () => void;
  onCancel: () => void;
}

export const RegistrationAlertDialog = ({
  status,
  state,
  onContinue,
  onCancel,
}: RegistrationAlertDialogProps) => {
  const isNewProviderGroup = status === REGISTRATION_STATUS.NEW_PROVIDER_GROUP;

  return (
    <ConfirmDialog
      show={!!status && status !== REGISTRATION_STATUS.REGISTERED}
      title={`Patient is not registered in ${state?.name ?? ""}`}
      description={
        isNewProviderGroup
          ? "Booking a visit will register the patient in a new state & create a new Athena ID in the following provider group:"
          : "Booking a visit will register the patient in a new state."
      }
      confirmLabel="Continue"
      onConfirm={onContinue}
      onCancel={onCancel}
    >
      {isNewProviderGroup && state?.providerGroup && (
        <p className="bg-placebo-lavender text-indigo rounded-md p-3 text-lg font-medium">
          {state.providerGroup.name}
        </p>
      )}
    </ConfirmDialog>
  );
};
